export default{
  methods:{
    parseEmoji(text){
      return text
        .replaceAll("+++", '<span class="emoji-tick"></span>')
        .replaceAll("---", '<span class="emoji-minus"></span>')
        .replaceAll(":kasa:", '<span class="emoji-kasa"></span>')
        .replaceAll("✔", '<span class="emoji-tick"></span>')
        .replaceAll("✅", '<span class="emoji-tick"></span>')
        .replaceAll("✖", '<span class="emoji-minus"></span>')
        .replaceAll("❌", '<span class="emoji-minus"></span>')
        .replaceAll("💲", '<span class="emoji-kasa"></span>');
    }
  }
}